<template>
  <div class="mt-6 ml-4 flex space-between space-x-4 justify-between m-2 mr-4 flex-end">
    <div>
      <h1 class="text-2xl text-gray-900 dark:text-gray-200 font-medium">
        AI Services Configuration
      </h1>
      <h1 class="text text-gray-900 dark:text-gray-200">
        Select the primary AI provider for your services.
      </h1>
    </div>
  </div>

  <div class="card bg-base-100 shadow-xl m-4">
    <div class="card-body">
      <h2 class="card-title">Select AI Provider</h2>
      <div class="form-control mt-4">
        <div class="flex flex-col space-y-2">
          <label class="flex items-center space-x-2 cursor-pointer p-2 rounded hover:bg-base-200 transition-colors">
            <input type="radio" name="provider" value="azure" v-model="selectedProvider" class="radio radio-primary" />
            <span class="label-text">Azure OpenAI</span>
          </label>
          <label class="flex items-center space-x-2 cursor-pointer p-2 rounded hover:bg-base-200 transition-colors">
            <input type="radio" name="provider" value="gcp" v-model="selectedProvider" class="radio radio-primary" />
            <span class="label-text">Google Cloud Platform (Vertex AI)</span>
          </label>
          <label class="flex items-center space-x-2 cursor-pointer p-2 rounded hover:bg-base-200 transition-colors">
            <input type="radio" name="provider" value="aws" v-model="selectedProvider" class="radio radio-primary" />
            <span class="label-text">AWS (Bedrock)</span>
          </label>
          <label class="flex items-center space-x-2 cursor-pointer p-2 rounded hover:bg-base-200 transition-colors">
            <input type="radio" name="provider" value="openai" v-model="selectedProvider" class="radio radio-primary" />
            <span class="label-text">OpenAI</span>
          </label>
        </div>
      </div>

      <div class="card-actions justify-end mt-6">
        <button class="btn" @click="saveConfiguration">Save Selection</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import axios from '../api/axiosInstance';
import { useToast } from 'vue-toastification';
import { isDefinedAndNotEmpty } from '../../isDefinedAndNotEmpty.js';

const toast = useToast();
const selectedProvider = ref('');


onMounted(async () => {
  try {
    const response = await axios.get('/api/ai-services-config');
    const config = response.data;
    
    if (isDefinedAndNotEmpty(config.provider) != false) {
      selectedProvider.value = config.provider;
    }
  } catch (error) {
    toast.error('Failed to load AI service configuration');
    console.error('Error loading configuration:', error);
  }
});

const saveConfiguration = async () => {
  try {
    const config = {
      provider: selectedProvider.value
    };

    await axios.post('/api/ai-services-config', config);
    toast.success('AI service provider selection saved successfully');
  } catch (error) {
    toast.error('Failed to save AI service configuration');
    console.error('Error saving configuration:', error);
  }
};
</script>

<style scoped>
.card {
  @apply shadow-lg;
}


.radio + .label-text {
  @apply ml-2;
}

input[type="radio"]:focus-visible {
  @apply outline outline-2 outline-offset-2 outline-primary;
}

</style> 